export default {"src":"/_next/static/media/SquareAcademicCap.070799eb.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};